import React, { useEffect, useState } from 'react';
import { Search, Building, CreditCard, CheckCircle, XCircle,InboxIcon  } from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import NavBar from '../../component/b2c/navBar/navBar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, accountUpdaterequestList, accountUpdaterequest, Url_For_View_Document } from '../../config/config';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useAuth } from '../../routes/Auth';

const BankDetailsRequest = () => {
    const { isAuthenticated } = useAuth();
        const [loading, setLoading] = useState(false);
        const { isToggleSidebar, isDarkMode } = useMyContext();
        const [requests, setRequests] = useState([]);
        const [searchQuery, setSearchQuery] = useState('');
        const [filteredRequests, setFilteredRequests] = useState([]);
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const [currentPage, setCurrentPage] = useState(1);
        const [totalRequests, setTotalRequests] = useState(0);
        const [limit, setLimit] = useState(10);
    
        useEffect(() => {
            getBankRequestsList();
        }, [currentPage, limit]);
    
        useEffect(() => {
            if (searchQuery.trim() === '') {
                setFilteredRequests(requests);
            } else {
                const filtered = requests.filter(request =>
                    request.account_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    request.name?.toLowerCase().includes(searchQuery.toLowerCase())
                );
                setFilteredRequests(filtered);
            }
        }, [searchQuery, requests]);
    
        const getBankRequestsList = async () => {
            try {
                const response = await fetch(
                    `${Base_Url}admin/${accountUpdaterequestList}?page=${currentPage}&limit=${limit}`,
                    {
                        method: 'GET',
                        headers: {
                            token: token,
                            cus_id: cus_id,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                if (!response.ok) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.message || 'Failed to fetch data');
                }
    
                const data = await response.json();
    
                if (data.status === 'success') {
                    setRequests(data.data);
                    setTotalRequests(data.pagination.totalItems);
                } else {
                    toast.error(`Error: ${data.message}`);
                }
            } catch (error) {
                toast.error(`Error: ${error.message}`);
            }
        };
    
    
        const handlePaginationChange = (event, value) => {
            setCurrentPage(value);
        };
    
        const handleLimitChange = (event) => {
            setLimit(event.target.value);
            setCurrentPage(1);
        };
    
        const handleDocumentClick = (url) => {
            if (!isAuthenticated) {
                window.location.href = '/dashboard';
            } else {
                window.open(url, '_blank');
            }
        };
    
        const handleStatusChange = (id, status) => {
            setRequests((prevRequests) =>
                prevRequests.map((request) =>
                    request.id === id ? { ...request, selectedStatus: status } : request
                )
            );
        };
        const handleStatusSubmit = async (id) => {
            const selectedRequest = requests.find((request) => request.id === id);
        
            if (!selectedRequest?.selectedStatus) {
                toast.error('Please select a status before submitting.');
                return;
            }
            const payload = {
                request_id: id,
                user_id: selectedRequest.user_id , 
                account_status: selectedRequest.selectedStatus.toLowerCase(), 
            };
            const url = Base_Url+"admin/"+accountUpdaterequest
            try {
                setLoading(true);
                const response = await axios.post(
                    url,
                    payload,
                    {
                        headers: {
                            token,
                            cus_id,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    getBankRequestsList();
                } else {
                    toast.error(`Error: ${response.data.message}`);
                }
            } catch (error) {   
                toast.error(`Error: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

    const getStatusDisplay = (request) => {
        switch (request.status.toLowerCase()) {
            case 'approved':
                return (
                    <div className="flex items-center gap-2 text-green-600 dark:text-green-400">
                        <CheckCircle className="w-5 h-5" />
                        <span className="font-medium">Request Approved</span>
                    </div>
                );
            case 'rejected':
                return (
                    <div className="flex items-center gap-2 text-red-600 dark:text-red-400">
                        <XCircle className="w-5 h-5" />
                        <span className="font-medium">Request Rejected</span>
                    </div>
                );
            case 'pending':
                return (
                    <div className="space-y-3">
                        <div className="flex items-center gap-4">
                            <label className="flex items-center gap-2 text-sm text-gray-800 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer transition-colors">
                                <input
                                    type="radio"
                                    name={`status-${request.id}`}
                                    value="Approved"
                                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                                    onChange={() => handleStatusChange(request.id, 'Approved')}
                                />
                                <span>Approve</span>
                            </label>
                            <label className="flex items-center gap-2 text-sm text-gray-800 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 cursor-pointer transition-colors">
                                <input
                                    type="radio"
                                    name={`status-${request.id}`}
                                    value="Rejected"
                                    className="w-4 h-4 text-red-600 focus:ring-red-500"
                                    onChange={() => handleStatusChange(request.id, 'Rejected')}
                                />
                                <span>Reject</span>
                            </label>
                        </div>
                        <button
                            className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center gap-2"
                            onClick={() => handleStatusSubmit(request.id)}
                            disabled={loading}
                        >
                            {loading ? (
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            ) : (
                                'Submit Decision'
                            )}
                        </button>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
            <NavBar />
        </div>
        <div className="flex flex-1 overflow-hidden">
            {isToggleSidebar && (
                <div className="fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20">
                    <Sidebar />
                </div>
            )}
            <div className="min-h-screen dark:bg-darkmodeColor p-4 w-full overflow-y-auto">
                <div className="max-w-7xl mx-auto mb-36">
                    <div className="mb-6 max-w-[360px]">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search by account number or name..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 dark:border-gray-700 
                                bg-white dark:bg-darkmodeColor text-gray-900 dark:text-white
                                focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                            />
                            <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        </div>
                    </div>

                    {filteredRequests.length === 0 ? (
                        <div className="flex flex-col items-center justify-center p-8 bg-white dark:bg-darkmodeColor rounded-lg shadow-custom-light dark:shadow-custom-dark">
                            <InboxIcon className="w-16 h-16 text-gray-400 dark:text-gray-500 mb-4" />
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                No Requests Found
                            </h3>
                            <p className="text-gray-600 dark:text-gray-400 text-center max-w-md">
                                {searchQuery 
                                    ? "No requests match your search criteria. Try adjusting your search terms."
                                    : "There are currently no bank detail update requests to display."}
                            </p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {filteredRequests.map((request) => (
                                <div
                                    key={request.id}
                                    className="bg-white dark:bg-darkmodeColor shadow-custom-light dark:shadow-custom-dark rounded-lg overflow-hidden  transition-shadow duration-300"
                                >
                                    <div className="p-6">
                                        <div className="border-b border-gray-200 dark:border-gray-700 pb-4 mb-4">
                                            <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-1">{request.name}</h2>
                                            <p className="text-sm text-gray-600 dark:text-gray-300">{request.company_name}</p>
                                        </div>
                                        <div className="space-y-6">
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2 mb-3">
                                                    <Building className="w-4 h-4" /> Bank Details
                                                </h3>
                                                <div className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
                                                    <p><span className="font-medium">Bank:</span> {request.bank_name}</p>
                                                    <p><span className="font-medium">Account:</span> {request.account_no}</p>
                                                    <p><span className="font-medium">Holder:</span> {request.account_holder_name}</p>
                                                    <p><span className="font-medium">IFSC:</span> {request.ifsc_code}</p>
                                                </div>
                                            </div>

                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2 mb-3">
                                                    <CreditCard className="w-4 h-4" /> Documents
                                                </h3>

                                                <div className="space-y-2">
                                                    {request.check_image && (
                                                        <div className="flex items-center justify-between">
                                                            <span className="text-sm text-gray-600 dark:text-gray-300">Cancel Check</span>
                                                            <button
                                                                className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                                                                onClick={() => handleDocumentClick(Url_For_View_Document + request.check_image)}
                                                            >
                                                                View Document
                                                            </button>
                                                        </div>
                                                    )}

                                                    {request.email_image && (
                                                        <div className="flex items-center justify-between">
                                                            <span className="text-sm text-gray-600 dark:text-gray-300">Email Approval</span>
                                                            <button
                                                                className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                                                                onClick={() => handleDocumentClick(Url_For_View_Document + request.email_image)}
                                                            >
                                                                View Document
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                                                {getStatusDisplay(request)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                     {filteredRequests.length > 0 && (
                        <div className="mt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
                            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                {`Total Requests: ${totalRequests}`}
                                {searchQuery && ` (Filtered: ${filteredRequests.length})`}
                            </span>

                            <div className="flex items-center gap-4">
                                <select
                                    value={limit}
                                    onChange={handleLimitChange}
                                    className="border rounded-lg px-3 py-2 text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                </select>

                                <Pagination
                                    count={Math.ceil(totalRequests / limit)}
                                    page={currentPage}
                                    onChange={handlePaginationChange}
                                    color="primary"
                                    variant="outlined"
                                    shape="rounded"
                                    size="medium"
                                    renderItem={(item) => (
                                        <PaginationItem
                                            {...item}
                                            className="paginationItem border text-blue-600 dark:text-blue-400 hover:text-white dark:hover:text-white border-gray-200 dark:border-gray-700"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                     )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BankDetailsRequest;